import { useNavigate } from "react-router-dom"
import { useOrgs } from "../../components/providers/OrgProvider"
import { IS_TEST } from "../config"
import { useEffectAfterMount } from "./useEffectAfterMount"

export function useOnChangeOrgRedirect(path: string) {
  const { currentOrgs } = useOrgs()
  const navigate = useNavigate()
  useEffectAfterMount(() => {
    if (!IS_TEST) {
      navigate(path)
    }
  }, [currentOrgs, navigate, path])
}
